import React, { forwardRef } from 'react'
import DateTime, { DatetimepickerProps } from 'react-datetime-3.1.1'
import { InputWithIcon, InputWithIconProps } from '../InputWithIcon'

// @ts-ignore
import { Calendar } from '../../../icons'
// @ts-ignore
import styles from './DateField.scss'

export type DateFieldProps = DatetimepickerProps & {
  inputProps?: Omit<InputProps, 'openCalendar'>;
}

export const DateField = forwardRef<HTMLInputElement, DateFieldProps>(
  ({ inputProps = {}, timeFormat = false, ...datetimePickerProps }, ref) => {
    return (
      <DateTime
        {...datetimePickerProps}
        timeFormat={timeFormat}
        renderInput={renderInput}
        inputProps={{ ...inputProps, ref: ref }}
      />
    )
  }
)

const renderInput: DateFieldProps['renderInput'] = (props, openCalendar, _closeCalendar) => {
  return <DateInput {...props} openCalendar={openCalendar} />
}

type InputProps = Omit<InputWithIconProps, 'children'> & {
  openCalendar: () => void;
  display?: string;
}

export const DateInput = forwardRef<HTMLInputElement, InputProps>(
  ({ openCalendar, display, className, ...props }, ref) => {
    return (
      <div className={styles.inputWrapper}>
        <InputWithIcon
          {...props}
          onIconClick={() => !props.disabled && openCalendar()}
          ref={ref}
        >
          <Calendar />
        </InputWithIcon>
        {display && <span className={styles.display}>{display}</span>}
      </div>
    )
  }
)
